module.exports = __webpack_public_path__ + "static/4e9076e6.product_2.gif";